module.exports = "\n/**\n * 文本可以做一些适当调整。\n */\n\n.md {\n  font-family: \"Helvetica Neue\", Helvetica, sans-serif;\n}\n\n.md h1, .md h2, .md h3, .md h4, .md h5, .md h6 {\n  display: inline-block;\n  color: #ddd;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 5px;\n}\n\n.md li {\n  margin: 5px 0;\n  line-height: 1.5;\n}\n\n.md h1, .md h2, .md h3, .md h4, .md h5, .md h6, .md ul, .md p {\n  margin: 0px;\n}\n\n\n/**\n * 还差最后一点就结束了。\n */\n\npre:hover{\n  box-shadow: 0px 0px 40px 5px rgba(255,255,255,0.4);\n}\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/style-text/styles2.css
// module id = KOIO
// module chunks = 1